// AdmissionForm.jsx
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import background from "../assets/formbackground.png"
import HeroBanner from "./admissionformleft";

function generateCaptcha(length = 6) {
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}

export default function AdmissionForm({status=true,classData="w-full ms-0 me-0 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3"}) {
  const [formData, setFormData] = useState({
    student_name: "",
    father_name: "",
    dob: "",
    class: "",
    campus: "",
    email: "",
    phone: "",
    phone2: "",
    message: "",
    company: "", // honeypot (must stay empty)
  });

  const [captchaCode, setCaptchaCode] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [checked, setChecked] = useState(false);
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [submittedName, setSubmittedName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [bgColor, setBgColor] = useState(["#ffb6c1", "#98fb98", "#add8e6"]);

  useEffect(() => {
    setCaptchaCode(generateCaptcha());
  }, []);

  const refreshCaptcha = () => {
    setCaptchaCode(generateCaptcha());
    setCaptchaInput("");
    setBgColor([
      `#${Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, "0")}`,
      `#${Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, "0")}`,
      `#${Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, "0")}`,
    ]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // sanitize phones (digits only)
    if (name === "phone" || name === "phone2") {
      const digits = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, [name]: digits }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateCaptcha = () => {
    if (captchaInput.toLowerCase() !== captchaCode.toLowerCase()) {
      return "Invalid captcha.";
    }
    return "";
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.student_name.trim())
      newErrors.student_name = "Student name is required.";
    if (!formData.dob) newErrors.dob = "Date of birth is required.";
    if (!formData.class) newErrors.class = "Please select a class.";
    if (!formData.campus) newErrors.campus = "Please select a campus.";
    if (!formData.phone.match(/^\d{10}$/))
      newErrors.phone = "Enter a valid 10-digit mobile number.";
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Enter a valid email address.";
    if (formData.company) newErrors.company = "Spam detected.";
    if (!captchaInput.trim()) {
      newErrors.captcha = "Captcha is required.";
    } else {
      const captchaError = validateCaptcha();
      if (captchaError) newErrors.captcha = captchaError;
    }
    if (!checked) newErrors.checkbox = "You must agree before submitting.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    setSubmittedName(formData.student_name);

    try {
      const res = await fetch("https://gantasoft.in/rankridgeschool/dev/v1/enquiries/enquiryform.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        body: new URLSearchParams({
          student_name: formData.student_name,
          father_name: formData.father_name,
          dob: formData.dob,
          class: formData.class,
          campus: formData.campus,
          email: formData.email,
          phone: formData.phone,
          phone2: formData.phone2,
          message: formData.message,
          // NOTE: don't send captchaCode to server; server validates only data.
          // Optionally include a server-side captcha in the future.
          company: formData.company, // honeypot
        }),
      });

      const result = await res.json();
      if (result?.success) {
        setShowModal(true);
        setFormData({
          student_name: "",
          father_name: "",
          dob: "",
          class: "",
          campus: "",
          email: "",
          phone: "",
          phone2: "",
          message: "",
          company: "",
        });
        setCaptchaInput("");
        setChecked(false);
        setErrors({});
        refreshCaptcha();
      } else {
        setErrors((prev) => ({
          ...prev,
          submit: result?.message || "Submission failed. Please try again.",
        }));
      }
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        submit: "Network error. Please try again.",
      }));
    } finally {
      setIsSubmitting(false);
    }
  };

  const fieldWrap = {
    hidden: { opacity: 0, y: 12 },
    show: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.02 * i, duration: 0.35 },
    }),
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 1 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}

      
      style={{backgroundImage:background,backgroundRepeat:'no-repeat',backgroundSize:'cover'}}
      className={classData}
    >
{status && <div className="col-span-2">
    <HeroBanner  />
</div>}
      <section  className="relative border   w-full overflow-hidden rounded-2xl  shadow-2xl ">
        {/* soft gradient ribbons */}
        
        <div className="relative px-6 md:px-8 py-2  "  >
          <div className="text-center" >
            <h2 className="text-2xl font-extrabold text-green-900 mb-[-20px]">
              Admission Enquiry
            </h2>
            {/* <p className="mt-2 text-sm text-gray-700">
              Submit your details, our admission facilitator will get back to you.
            </p> */}
            <br></br>
<div className="mx-auto h-1 w-32 rounded-full bg-gradient-to-r from-[#20b2aa] via-green-500 to-[#20b2aa]" />
          </div>

          <form onSubmit={handleSubmit} className="mt-8 grid grid-cols-2 gap-4">
            {/* Student Name */}
            <motion.div variants={fieldWrap} initial="hidden" whileInView="show" custom={1} viewport={{ once: true }}>
              <input
                type="text"
                name="student_name"
                value={formData.student_name}
                onChange={handleChange}
                placeholder="Student Name*"
                className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 placeholder-black outline-none ring-emerald-200 transition focus:border-emerald-400 focus:ring-4 shadow-2xl "
              />
              {errors.student_name && <p className="mt-1 text-sm text-red-600">{errors.student_name}</p>}
            </motion.div>

            {/* Father Name */}
            <motion.div variants={fieldWrap} initial="hidden" whileInView="show" custom={2} viewport={{ once: true }}>
              <input
                type="text"
                name="father_name"
                value={formData.father_name}
                onChange={handleChange}
                placeholder="Parent Name"
                className="w-full shadow-2xl rounded-lg border border-gray-300 bg-white px-4 py-3 placeholder-black outline-none ring-emerald-200 transition focus:border-emerald-400 focus:ring-4"
              />
            </motion.div>

            {/* DOB */}
            <motion.div variants={fieldWrap} initial="hidden" whileInView="show" custom={3} viewport={{ once: true }}>
              {/* <label className="mb-1  block text-sm font-medium text-gray-700">Date of Birth</label> */}
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                className="w-full shadow-2xl rounded-lg border border-gray-300 bg-white px-4 py-3 placeholder-black outline-none ring-emerald-200 transition focus:border-emerald-400 focus:ring-4"
              />
              {errors.dob && <p className="mt-1 text-sm text-red-600">{errors.dob}</p>}
            </motion.div>

            {/* Class */}
            <motion.div variants={fieldWrap} initial="hidden" whileInView="show" custom={4} viewport={{ once: true }}>
              <select
                name="class"
                value={formData.class}
                onChange={handleChange}
                className="w-full shadow-2xl rounded-lg border border-gray-300 bg-white px-4 py-3 outline-none ring-emerald-200 transition focus:border-emerald-400 focus:ring-4"
                required
              >
                <option value="">Select Class</option>
                <option value="Nursery">Nursery</option>
                <option value="LKG">LKG</option>
                <option value="UKG">UKG</option>
                {Array.from({ length: 12 }, (_, i) => `Grade ${i + 1}`).map((g) => (
                  <option key={g} value={g}>{g}</option>
                ))}
              </select>
              {errors.class && <p className="mt-1 text-sm text-red-600">{errors.class}</p>}
            </motion.div>

            {/* Campus */}
            <motion.div variants={fieldWrap} initial="hidden" whileInView="show" custom={5} viewport={{ once: true }}>
              <select
                name="campus"
                value={formData.campus}
                onChange={handleChange}
                className="w-full  shadow-2xl rounded-lg border border-gray-300 bg-white px-4 py-3 outline-none ring-emerald-200 transition focus:border-emerald-400 focus:ring-4"
                required
              >
                <option value="">Select Campus</option>
                <option value="Hyderabad">Hyderabad</option>
                <option value="Vijayawada">Vijayawada</option>
              </select>
              {errors.campus && <p className="mt-1 text-sm text-red-600">{errors.campus}</p>}
            </motion.div>

            {/* Email */}
            <motion.div variants={fieldWrap} initial="hidden" whileInView="show" custom={6} viewport={{ once: true }}>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                className="w-full shadow-2xl rounded-lg border border-gray-300 bg-white px-4 py-3 placeholder-black outline-none ring-emerald-200 transition focus:border-emerald-400 focus:ring-4"
              />
              {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
            </motion.div>

            {/* Phone */}
            <motion.div className="col-span-2" variants={fieldWrap} initial="hidden" whileInView="show" custom={7} viewport={{ once: true }}>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter Mobile Number"
                className="w-full  shadow-2xl rounded-lg border border-gray-300 bg-white px-4 py-3 placeholder-black outline-none ring-emerald-200 transition focus:border-emerald-400 focus:ring-4"
              />
              {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
            </motion.div>

            {/* Phone 2 */}
            {/* <motion.div variants={fieldWrap} initial="hidden" whileInView="show" custom={8} viewport={{ once: true }}>
              <input
                type="text"
                name="phone2"
                value={formData.phone2}
                onChange={handleChange}
                placeholder="WhatsApp Mobile Number"
                className="w-full shadow-2xl rounded-lg border border-gray-300 bg-white px-4 py-3 placeholder-black outline-none ring-emerald-200 transition focus:border-emerald-400 focus:ring-4"
              />
            </motion.div> */}

            {/* Message */}
            {/* <motion.div variants={fieldWrap} initial="hidden" whileInView="show" custom={9} viewport={{ once: true }}>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                className="h-28 w-full shadow-2xl rounded-lg border border-gray-300 bg-white px-4 py-3 placeholder-black outline-none ring-emerald-200 transition focus:border-emerald-400 focus:ring-4"
              />
            </motion.div> */}

            {/* CAPTCHA */}
            <motion.div  className="col-span-2"  variants={fieldWrap} initial="hidden" whileInView="show" custom={10} viewport={{ once: true }}>
              <label className="mb-1 block text-sm font-semibold text-gray-700">
                Captcha <span className="text-red-600">*</span>
              </label>
              <div className="mb-2 flex items-center">
                <div className="relative flex h-10 w-40 select-none items-center justify-center overflow-hidden rounded border border-gray-300 bg-white font-mono text-lg tracking-widest">
                  <div
                    className="absolute h-10 w-10 rounded-full opacity-30"
                    style={{ backgroundColor: bgColor[0], top: "-10px", left: "-10px" }}
                  />
                  <div
                    className="absolute h-10 w-10 rounded-full opacity-30"
                    style={{ backgroundColor: bgColor[1], top: "5px", left: "20px" }}
                  />
                  <div
                    className="absolute h-10 w-10 rounded-full opacity-30"
                    style={{ backgroundColor: bgColor[2], top: "-5px", left: "40px" }}
                  />
                  <span className="relative z-10">{captchaCode}</span>
                </div>

                <button
                  type="button"
                  onClick={refreshCaptcha}
                  className="rounded-md px-2 py-2 text-gray-600 transition hover:bg-emerald-50 hover:text-emerald-700"
                  title="Refresh captcha"
                  aria-label="Refresh captcha"
                >
                  🔄
                </button>

                <input
                  type="text"
                  placeholder="Enter Captcha"
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                  className="flex-1 rounded border border-gray-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-emerald-500"
                />
              </div>
              {errors.captcha && <p className="text-sm text-red-600">{errors.captcha}</p>}
            </motion.div>

            {/* Honeypot (hidden) */}
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              className="hidden"
              tabIndex={-1}
              autoComplete="off"
            />

            {/* Consent */}
            <motion.div className="col-span-2" variants={fieldWrap} initial="hidden" whileInView="show" custom={11} viewport={{ once: true }}>
              <div className="flex items-start gap-2">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                  className="mt-1"
                />
                <label className="text-sm text-gray-700">
                  I agree to receive information regarding my submitted enquiry  on{" "}
                  <strong>Rankridge Schools</strong>{" "}
                  <span className="text-red-600">*</span>
                </label>
              </div>
              {errors.checkbox && <p className="mt-1 text-sm text-red-600">{errors.checkbox}</p>}
            </motion.div>

            {/* Submit */}
            <motion.div className="col-span-2 text-center" variants={fieldWrap} initial="hidden" whileInView="show" custom={12} viewport={{ once: true }}>
              <button
                type="submit"
                disabled={isSubmitting}
                className="inline-flex items-center gap-2 rounded-md bg-[#20b2aa] px-6 py-3 font-bold text-black shadow-sm ring-1 ring-black/5 transition
                           hover:-translate-y-0.5 hover:shadow-lg hover:ring-black/10 disabled:cursor-not-allowed disabled:opacity-70"
              >
                {isSubmitting && (
                  <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-black border-r-transparent" />
                ) }
                {isSubmitting ? "Submitting..." : "Submit Enquiry"}
              </button>
              {errors.submit && <p className="mt-2 text-sm text-red-600">{errors.submit}</p>}
            </motion.div>
      
          </form>
        </div>
      </section>

      {/* Success Modal */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 8 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 8 }}
              transition={{ type: "spring", stiffness: 160, damping: 16 }}
              className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-xl"
            >
              <h2 className="mb-3 text-xl font-bold text-green-800">Registered Successfully!</h2>
              <p className="mb-6 text-gray-700">
                Thank you {submittedName || "Student"}. Our team will contact you soon.
              </p>
           
              <button
                onClick={() => setShowModal(false)}
                className="rounded-md bg-green-900 px-6 py-2  text-white transition hover:bg-green-800"
              >
                Close
              </button>
          
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
